
<div class="alert d-flex word-wrap alert-{{className}}"><i class="fas fa-fw mr-3" [class]="iconClass"></i>
  <ng-content></ng-content>
</div>